/* ==========================================================================
   DOOMSDAYSURVIVALIST.COM — INTERACTIVE STOREFRONT & 28-CATEGORY CUSTOMIZER
   Works natively in Shopify Online Store 2.0 AND Standalone Live Preview
   ========================================================================== */
(function () {
  "use strict";

  const catalog = window.DOOMSDAY_CATALOG;
  if (!catalog) {
    console.error("DOOMSDAY_CATALOG failed to load.");
    return;
  }

  const assetBase = window.DSG_ASSET_BASE || "assets/";
  const items = catalog.items || [];
  const packages = catalog.packages || [];
  const storagePlans = catalog.storagePlans || [];

  const skuMap = {};
  const byCategory = {};
  items.forEach(function (it) {
    skuMap[it.sku] = it;
    if (!byCategory[it.catCode]) byCategory[it.catCode] = [];
    byCategory[it.catCode].push(it);
  });

  const storageMap = {};
  storagePlans.forEach(function (sp) {
    storageMap[sp.id] = sp;
  });

  function fmtMoney(n) {
    return "$" + Number(n || 0).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function esc(str) {
    const d = document.createElement("div");
    d.textContent = str == null ? "" : String(str);
    return d.innerHTML;
  }

  // -------------------- CART STATE --------------------
  let cart = [];
  try {
    const saved = localStorage.getItem("dsg_cart_v1");
    if (saved) cart = JSON.parse(saved) || [];
  } catch (e) {
    cart = [];
  }

  function saveCart() {
    try {
      localStorage.setItem("dsg_cart_v1", JSON.stringify(cart));
    } catch (e) {}
    renderCartBadge();
    renderCartDrawer();
  }

  function addToCart(entry) {
    cart.push(entry);
    saveCart();
    openCartDrawer();

    // If running inside live Shopify storefront with variant mapping, also sync to /cart/add.js
    if (window.Shopify && window.DSG_VARIANT_MAP && entry.sku && window.DSG_VARIANT_MAP[entry.sku]) {
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: [{
            id: window.DSG_VARIANT_MAP[entry.sku],
            quantity: entry.qty || 1,
            properties: entry.properties || {}
          }]
        })
      }).catch(function () {});
    }
  }

  function removeFromCart(idx) {
    cart.splice(idx, 1);
    saveCart();
  }

  function renderCartBadge() {
    const els = document.querySelectorAll("[data-cart-count]");
    const totalCount = cart.reduce(function (acc, c) { return acc + (c.qty || 1); }, 0);
    els.forEach(function (el) { el.textContent = totalCount; });
  }

  // -------------------- 28 MANDATORY CATEGORIES STRIP --------------------
  function renderCategoryChecklist() {
    const wrap = document.getElementById("dsg-28-categories");
    if (!wrap) return;
    const mandatoryOrder = [
      ["a", "Tent(s)"], ["b", "Camping Tool Kit"], ["c", "First Aid w/ Clotter"], ["d", "Sanitation"],
      ["e", "Shower"], ["f", "Cooking Equipment"], ["g", "Generator"], ["h", "Power Inverter"],
      ["i", "Portable Power Bank"], ["j", "Water Filtration"], ["k", "Global Walkie Talkies"], ["l", "Night Vision Binoculars"],
      ["m", "Fishing Gear"], ["n", "Speargun"], ["o", "Scuba Pony Tank & Mask"], ["p", "Gas Mask"],
      ["q", "Propane Torch / Lighter"], ["r", "Fire Starter"], ["s", "Lantern"], ["t", "Flashlight"],
      ["u", "Solar Crank Radio"], ["v", "Weapons (Cart + Tactical)"], ["w", "Crossbow"], ["x", "Trapping Equipment"],
      ["y", "Taser"], ["z", "Tear Gas"], ["aa", "Bear Spray"], ["bb", "Electric ATV"],
      ["ISO", "Sized Steel Container"]
    ];
    wrap.innerHTML = mandatoryOrder.map(function (pair) {
      return '<div class="dsg-cat-pill"><code>' + esc(pair[0]) + '</code><span>' + esc(pair[1]) + '</span></div>';
    }).join("");
  }

  // -------------------- 6 CORE ESCALATING PACKAGES --------------------
  function renderCorePackages() {
    const grid = document.getElementById("dsg-packages-grid");
    if (!grid) return;

    const corePkgs = packages.filter(function (p) { return p.tierNumber <= 6; });
    grid.innerHTML = corePkgs.map(function (pkg) {
      const cnt = skuMap[pkg.containerSku] || {};
      const sp = storageMap[pkg.storagePlanId] || {};
      const atvLine = pkg.bom.find(function (b) { return b.catCode === "bb"; }) || {};
      const wpnLine = pkg.bom.find(function (b) { return b.catCode === "v"; }) || {};
      const pwbLine = pkg.bom.find(function (b) { return b.catCode === "i"; }) || {};
      const genLine = pkg.bom.find(function (b) { return b.catCode === "g"; }) || {};

      const manifestRows = pkg.bom.map(function (b) {
        return '<tr>' +
          '<td style="font-family:var(--font-mono);color:var(--accent-amber);">' + esc(b.catCode) + '</td>' +
          '<td>' + esc(b.catName) + '</td>' +
          '<td>' + esc(b.name) + '</td>' +
          '<td style="text-align:center;">' + b.qty + '</td>' +
          '<td style="text-align:right;font-family:var(--font-mono);">' + fmtMoney(b.lineRetailPrice) + '</td>' +
          '</tr>';
      }).join("");

      return '<article class="dsg-pkg-card">' +
        '<div class="dsg-pkg-media">' +
          '<img src="' + esc(assetBase + pkg.image) + '" alt="' + esc(pkg.name) + '" loading="lazy">' +
          '<span class="dsg-pkg-tier-badge">' + esc(pkg.protocolCode) + ' &bull; TIER ' + pkg.tierNumber + '</span>' +
          '<span class="dsg-pkg-cap-badge">' + esc(pkg.personnel) + '</span>' +
        '</div>' +
        '<div class="dsg-pkg-body">' +
          '<h3>' + esc(pkg.name) + '</h3>' +
          '<p class="dsg-pkg-tagline">' + esc(pkg.tagline) + '</p>' +
          '<div class="dsg-pkg-price-row">' +
            '<div>' +
              '<div class="dsg-pkg-price">' + fmtMoney(pkg.retailPrice) + '</div>' +
              '<div style="font-size:11px;color:var(--accent-emerald);">Includes All 28 Categories + Steel Container</div>' +
            '</div>' +
            '<div class="dsg-pkg-meta">' +
              '<div>Off-Site Vault Option:</div>' +
              '<strong style="color:var(--text-primary);">' + fmtMoney(sp.retailMonthly) + '/mo</strong>' +
            '</div>' +
          '</div>' +
          '<ul class="dsg-pkg-highlights">' +
            '<li><span><strong>Container:</strong> ' + esc(cnt.name || "") + '</span></li>' +
            '<li><span><strong>Electric ATV:</strong> ' + esc(atvLine.name || "") + '</span></li>' +
            '<li><span><strong>Armory:</strong> ' + esc(wpnLine.name || "") + '</span></li>' +
            '<li><span><strong>Power Grid:</strong> ' + esc(genLine.name || "") + ' + ' + esc(pwbLine.name || "") + '</span></li>' +
          '</ul>' +
          '<div class="dsg-pkg-actions">' +
            '<button type="button" class="btn-secondary" data-customize-pkg="' + esc(pkg.id) + '">Exchange / Add Gear</button>' +
            '<button type="button" class="btn-primary" data-quickadd-pkg="' + esc(pkg.id) + '">Deploy Package</button>' +
            '<button type="button" class="dsg-manifest-toggle" data-toggle-manifest="' + esc(pkg.id) + '">&#9662; View All 29 Included Line Items (a&ndash;bb + Container)</button>' +
          '</div>' +
          '<div id="manifest-' + esc(pkg.id) + '" style="display:none;margin-top:14px;max-height:300px;overflow-y:auto;border:1px solid var(--border-grid);border-radius:6px;">' +
            '<table class="dsg-table" style="font-size:12px;">' +
              '<thead><tr><th>Code</th><th>Category</th><th>Item</th><th>Qty</th><th style="text-align:right;">2x Price</th></tr></thead>' +
              '<tbody>' + manifestRows + '</tbody>' +
            '</table>' +
          '</div>' +
        '</div>' +
      '</article>';
    }).join("");
  }

  // -------------------- SUPREME 1,500 SQ FT BUNKER SECTION --------------------
  function renderSupremeBunker() {
    const wrap = document.getElementById("dsg-supreme-bunker-mount");
    if (!wrap) return;
    const pkg = packages.find(function (p) { return p.tierNumber === 7; });
    if (!pkg) return;
    const sp = storageMap[pkg.storagePlanId] || {};

    wrap.innerHTML =
      '<div class="dsg-bunker-card">' +
        '<div class="dsg-bunker-grid">' +
          '<div class="dsg-bunker-media">' +
            '<img src="' + esc(assetBase + pkg.image) + '" alt="' + esc(pkg.name) + '">' +
          '</div>' +
          '<div class="dsg-bunker-content">' +
            '<div class="dsg-kicker">FLAGSHIP TIER VII &bull; 1,500 SQ FT TURNKEY NBC/CBRN BUNKER</div>' +
            '<h2 style="font-size:clamp(28px,3.2vw,40px);margin:0 0 10px;font-weight:900;">' + esc(pkg.name) + '</h2>' +
            '<p style="color:var(--text-secondary);margin:0 0 18px;font-size:15.5px;">' +
              'A fully functional <strong>1,500 sq ft underground structural steel NBC/CBRN survival bunker complex</strong> ' +
              '(triple-linked 3&times; 10\'&times;50\' modules) paired with a <strong>40ft High-Cube Double-Door Surface Container</strong>, ' +
              '<strong>two 10,000W Dual-Motor AWD LiFePO4 Electric Tactical UTVs</strong>, dual 11,500W tri-fuel generators, ' +
              'dual 6,144Wh EcoFlow DELTA Pro Ultra cores, thermal rangefinding optics, and multi-operator redundancy across all 28 survival categories.' +
            '</p>' +
            '<div class="dsg-pkg-price-row" style="margin-bottom:14px;">' +
              '<div>' +
                '<div style="font-size:11.5px;color:var(--text-muted);text-transform:uppercase;font-family:var(--font-mono);">Turnkey Package Price (2.0x Verified Supplier Cost)</div>' +
                '<div class="dsg-pkg-price" style="font-size:34px;">' + fmtMoney(pkg.retailPrice) + '</div>' +
              '</div>' +
              '<div class="dsg-pkg-meta">' +
                '<div>Pre-Deployment Surface Hangar:</div>' +
                '<strong style="color:var(--accent-amber);">' + fmtMoney(sp.retailMonthly) + '/mo</strong>' +
                '<div>Lead Time: 90&ndash;180 Days</div>' +
              '</div>' +
            '</div>' +
            '<div class="dsg-bunker-specs">' +
              '<div class="dsg-bunker-spec-item"><strong>1,500 Sq Ft Steel Complex</strong><span>Gas-tight blast doors, decon airlock, master &amp; bunk suites, full galley, 2 baths &amp; hidden armory</span></div>' +
              '<div class="dsg-bunker-spec-item"><strong>Swiss AndAir NBC Overpressure</strong><span>Positive-pressure CBRN nuclear/biological/chemical filtration + blast valves &amp; escape hatch</span></div>' +
              '<div class="dsg-bunker-spec-item"><strong>Dual 10kW AWD Electric UTVs</strong><span>2&times; Kandi Innovator e10K 4WD LiFePO4 UTVs w/ 3,500-lb winches staged in 40ft tunnel vault</span></div>' +
              '<div class="dsg-bunker-spec-item"><strong>100% Customizable Loadout</strong><span>Upgrade to Rising S 30\'&times;50\' Plate-Steel Bunker (+$120,000) or add custom weapons &amp; dive gear</span></div>' +
            '</div>' +
            '<div style="display:flex;flex-wrap:wrap;gap:12px;margin-top:8px;">' +
              '<button type="button" class="btn-primary" data-customize-pkg="' + esc(pkg.id) + '">Configure Bunker &amp; 28-Category Manifest</button>' +
              '<button type="button" class="btn-secondary" data-quickadd-pkg="' + esc(pkg.id) + '">Reserve Supreme Package</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  // -------------------- OFF-SITE STORAGE SECTION --------------------
  let storageBilling = "monthly";

  function renderOffsiteStorage() {
    const tbody = document.getElementById("dsg-storage-tbody");
    if (!tbody) return;
    tbody.innerHTML = storagePlans.map(function (sp) {
      const activePrice = storageBilling === "annual" ? sp.retailAnnual : sp.retailMonthly;
      const suffix = storageBilling === "annual" ? "/yr" : "/mo";
      return '<tr>' +
        '<td><strong style="color:var(--text-primary);">' + esc(sp.name) + '</strong><div style="font-size:12px;color:var(--text-muted);">' + esc(sp.features) + '</div></td>' +
        '<td>' + esc(sp.forPackages) + '</td>' +
        '<td style="font-family:var(--font-mono);">' + esc(sp.unitSize) + '</td>' +
        '<td style="font-family:var(--font-mono);color:var(--text-muted);">' + fmtMoney(sp.avgMarketMonthly) + '/mo</td>' +
        '<td style="font-family:var(--font-mono);font-weight:800;color:var(--accent-amber);font-size:16px;">' + fmtMoney(activePrice) + suffix + '</td>' +
        '<td><button type="button" class="btn-secondary" style="padding:8px 14px;font-size:12px;" data-add-storage="' + esc(sp.id) + '">Reserve Bay</button></td>' +
      '</tr>';
    }).join("");
  }

  // -------------------- 181-SKU ARMORY & EXCHANGE CATALOG --------------------
  function populateArmoryFilters() {
    const sel = document.getElementById("dsg-armory-cat");
    if (!sel) return;
    const seen = {};
    const opts = ['<option value="ALL">All 30 Categories (' + items.length + ' In-Stock SKUs)</option>'];
    items.forEach(function (it) {
      if (!seen[it.catCode]) {
        seen[it.catCode] = true;
        const count = byCategory[it.catCode].length;
        opts.push('<option value="' + esc(it.catCode) + '">[' + esc(it.catCode) + '] ' + esc(it.catName) + ' (' + count + ')</option>');
      }
    });
    sel.innerHTML = opts.join("");
  }

  function renderArmoryGrid() {
    const grid = document.getElementById("dsg-armory-grid");
    if (!grid) return;
    const catVal = (document.getElementById("dsg-armory-cat") || {}).value || "ALL";
    const srcVal = (document.getElementById("dsg-armory-source") || {}).value || "ALL";
    const q = ((document.getElementById("dsg-armory-search") || {}).value || "").trim().toLowerCase();

    const filtered = items.filter(function (it) {
      if (catVal !== "ALL" && it.catCode !== catVal) return false;
      if (srcVal === "CART" && it.sourceTag.indexOf("Cart") === -1) return false;
      if (q && (it.name.toLowerCase().indexOf(q) === -1 && it.catName.toLowerCase().indexOf(q) === -1 && it.sku.toLowerCase().indexOf(q) === -1)) return false;
      return true;
    });

    const countEl = document.getElementById("dsg-armory-count");
    if (countEl) countEl.textContent = "Showing " + filtered.length + " of " + items.length + " verified in-stock SKUs";

    grid.innerHTML = filtered.slice(0, 48).map(function (it) {
      return '<div class="dsg-sku-card">' +
        '<div class="dsg-sku-top">' +
          '<span style="color:var(--accent-amber);">[' + esc(it.catCode) + '] ' + esc(it.sku) + '</span>' +
          '<span class="dsg-source-tag">' + esc(it.sourceTag) + '</span>' +
        '</div>' +
        '<h4>' + esc(it.name) + '</h4>' +
        '<p class="dsg-sku-notes">' + esc(it.notes) + ' &bull; <span style="color:var(--text-secondary);">Lead: ' + esc(it.leadTime) + '</span></p>' +
        '<div class="dsg-sku-bottom">' +
          '<div>' +
            '<strong style="font-family:var(--font-mono);font-size:18px;color:var(--accent-amber);">' + fmtMoney(it.retailPrice) + '</strong>' +
            '<div style="font-size:11px;color:var(--text-muted);">' + esc(it.stockStatus) + '</div>' +
          '</div>' +
          '<button type="button" class="btn-secondary" style="padding:8px 13px;font-size:12px;" data-add-sku="' + esc(it.sku) + '">+ Add Item</button>' +
        '</div>' +
      '</div>';
    }).join("");
  }

  // -------------------- INTERACTIVE PACKAGE CUSTOMIZER MODAL --------------------
  let activeConfig = null;

  function openCustomizer(pkgId) {
    const pkg = packages.find(function (p) { return p.id === pkgId; });
    if (!pkg) return;

    activeConfig = {
      pkg: pkg,
      storageOption: "none", // 'none', 'monthly', 'annual'
      storagePlanId: pkg.storagePlanId,
      lines: pkg.bom.map(function (b) {
        return {
          catCode: b.catCode,
          catName: b.catName,
          baseSku: b.sku,
          baseQty: b.qty,
          baseLineRetail: b.lineRetailPrice,
          selectedSku: b.sku,
          selectedQty: b.qty
        };
      }),
      extraAddons: [] // { sku, qty }
    };

    renderCustomizerModal();
    const modal = document.getElementById("dsg-customizer-backdrop");
    if (modal) modal.classList.add("open");
  }

  function closeCustomizer() {
    const modal = document.getElementById("dsg-customizer-backdrop");
    if (modal) modal.classList.remove("open");
  }

  function calcConfigTotals() {
    if (!activeConfig) return { base: 0, exchangeDelta: 0, addonsTotal: 0, storageTotal: 0, grandTotal: 0 };
    const base = activeConfig.pkg.retailPrice;
    let configuredLinesTotal = 0;
    activeConfig.lines.forEach(function (ln) {
      const it = skuMap[ln.selectedSku];
      configuredLinesTotal += (it ? it.retailPrice : 0) * ln.selectedQty;
    });
    const exchangeDelta = configuredLinesTotal - base;

    let addonsTotal = 0;
    activeConfig.extraAddons.forEach(function (ad) {
      const it = skuMap[ad.sku];
      addonsTotal += (it ? it.retailPrice : 0) * ad.qty;
    });

    let storageTotal = 0;
    const sp = storageMap[activeConfig.storagePlanId];
    if (sp && activeConfig.storageOption === "monthly") storageTotal = sp.retailMonthly;
    if (sp && activeConfig.storageOption === "annual") storageTotal = sp.retailAnnual;

    return {
      base: base,
      exchangeDelta: exchangeDelta,
      addonsTotal: addonsTotal,
      storageTotal: storageTotal,
      grandTotal: base + exchangeDelta + addonsTotal + storageTotal
    };
  }

  function renderCustomizerModal() {
    if (!activeConfig) return;
    const pkg = activeConfig.pkg;
    const titleEl = document.getElementById("dsg-cust-title");
    if (titleEl) titleEl.textContent = "Customize " + pkg.protocolCode + ": " + pkg.name;

    const bodyEl = document.getElementById("dsg-cust-body");
    const sp = storageMap[activeConfig.storagePlanId] || {};

    const storageHtml =
      '<div style="background:var(--bg-obsidian);border:1px solid var(--border-strong);border-radius:10px;padding:16px;margin-bottom:20px;">' +
        '<div style="display:flex;flex-wrap:wrap;justify-content:space-between;align-items:center;gap:12px;">' +
          '<div>' +
            '<strong style="color:var(--accent-amber);font-family:var(--font-mono);font-size:12px;text-transform:uppercase;">Matched Off-Site Hardened Storage Option (2.0x National Avg Space Rate)</strong>' +
            '<div style="font-size:15px;font-weight:700;margin-top:3px;">' + esc(sp.name) + ' &mdash; ' + esc(sp.unitSize) + '</div>' +
            '<div style="font-size:12.5px;color:var(--text-muted);">' + esc(sp.features) + '</div>' +
          '</div>' +
          '<select id="dsg-cust-storage-select" class="dsg-select" style="min-width:290px;">' +
            '<option value="none"' + (activeConfig.storageOption === "none" ? " selected" : "") + '>Direct Freight Delivery to My Property ($0/mo storage)</option>' +
            '<option value="monthly"' + (activeConfig.storageOption === "monthly" ? " selected" : "") + '>Add Off-Site Storage — Monthly (' + fmtMoney(sp.retailMonthly) + '/mo)</option>' +
            '<option value="annual"' + (activeConfig.storageOption === "annual" ? " selected" : "") + '>Add Off-Site Storage — Annual Prepay (' + fmtMoney(sp.retailAnnual) + '/yr)</option>' +
          '</select>' +
        '</div>' +
      '</div>';

    const rowsHtml = activeConfig.lines.map(function (ln, idx) {
      const catOptions = byCategory[ln.catCode] || [];
      const curItem = skuMap[ln.selectedSku];
      const curLineVal = (curItem ? curItem.retailPrice : 0) * ln.selectedQty;
      const delta = curLineVal - ln.baseLineRetail;
      const isMod = (ln.selectedSku !== ln.baseSku || ln.selectedQty !== ln.baseQty);
      const deltaLabel = delta === 0
        ? '<span style="color:var(--text-muted);">Included (' + fmtMoney(curLineVal) + ')</span>'
        : (delta > 0
            ? '<span style="color:var(--accent-amber);font-weight:700;">+' + fmtMoney(delta) + ' Upgrade</span>'
            : '<span style="color:var(--accent-emerald);font-weight:700;">-' + fmtMoney(Math.abs(delta)) + ' Credit</span>');

      const optsHtml = catOptions.map(function (opt) {
        const diffPerUnit = opt.retailPrice - (skuMap[ln.baseSku] ? skuMap[ln.baseSku].retailPrice : 0);
        const diffTag = opt.sku === ln.baseSku
          ? " [Base Included - " + fmtMoney(opt.retailPrice) + "]"
          : (diffPerUnit >= 0
              ? " [Exchange +" + fmtMoney(diffPerUnit) + "/ea -> " + fmtMoney(opt.retailPrice) + "]"
              : " [Exchange -" + fmtMoney(Math.abs(diffPerUnit)) + "/ea -> " + fmtMoney(opt.retailPrice) + "]");
        return '<option value="' + esc(opt.sku) + '"' + (opt.sku === ln.selectedSku ? " selected" : "") + '>' +
          esc(opt.name) + esc(diffTag) + '</option>';
      }).join("");

      return '<div class="dsg-customizer-row' + (isMod ? " modified" : "") + '">' +
        '<div>' +
          '<div style="font-family:var(--font-mono);font-size:11.5px;color:var(--accent-amber);">CATEGORY [' + esc(ln.catCode) + ']</div>' +
          '<strong style="font-size:14px;">' + esc(ln.catName) + '</strong>' +
        '</div>' +
        '<div style="display:flex;gap:10px;flex-wrap:wrap;align-items:center;">' +
          '<select class="dsg-select" style="flex:1;min-width:240px;" data-line-sku="' + idx + '">' + optsHtml + '</select>' +
          '<label style="font-size:12px;color:var(--text-muted);display:flex;align-items:center;gap:6px;">Qty:' +
            '<input type="number" min="1" max="20" class="dsg-input" style="width:68px;padding:8px;" data-line-qty="' + idx + '" value="' + ln.selectedQty + '">' +
          '</label>' +
        '</div>' +
        '<div style="text-align:right;font-family:var(--font-mono);font-size:13px;">' + deltaLabel + '</div>' +
      '</div>';
    }).join("");

    // Extra Add-On Picker
    const allOpts = items.map(function (it) {
      return '<option value="' + esc(it.sku) + '">[' + esc(it.catCode) + '] ' + esc(it.name) + ' (' + fmtMoney(it.retailPrice) + ')</option>';
    }).join("");

    const extraListHtml = activeConfig.extraAddons.map(function (ad, aIdx) {
      const it = skuMap[ad.sku] || {};
      return '<div style="display:flex;justify-content:space-between;align-items:center;padding:10px 14px;background:var(--bg-obsidian);border:1px solid var(--accent-emerald);border-radius:6px;margin-top:8px;">' +
        '<div><strong style="color:var(--accent-emerald);">+ EXTRA ADD-ON:</strong> ' + esc(it.name) + ' &times; ' + ad.qty + '</div>' +
        '<div style="display:flex;align-items:center;gap:12px;">' +
          '<span style="font-family:var(--font-mono);font-weight:700;">+' + fmtMoney((it.retailPrice || 0) * ad.qty) + '</span>' +
          '<button type="button" class="btn-secondary" style="padding:4px 10px;font-size:11px;" data-remove-addon="' + aIdx + '">Remove</button>' +
        '</div>' +
      '</div>';
    }).join("");

    const addonsBoxHtml =
      '<div style="margin-top:22px;padding:18px;background:var(--bg-card);border:1px solid var(--border-strong);border-radius:10px;">' +
        '<h4 style="margin:0 0 10px;color:var(--accent-amber);">+ Add Extra Items / Weapons / Spare Batteries to Your Container</h4>' +
        '<div style="display:flex;flex-wrap:wrap;gap:10px;">' +
          '<select id="dsg-extra-addon-sku" class="dsg-select" style="flex:1;min-width:260px;">' + allOpts + '</select>' +
          '<input id="dsg-extra-addon-qty" type="number" min="1" max="50" value="1" class="dsg-input" style="width:80px;">' +
          '<button type="button" id="dsg-btn-add-extra" class="btn-secondary">+ Add to Container</button>' +
        '</div>' +
        extraListHtml +
      '</div>';

    bodyEl.innerHTML = storageHtml + rowsHtml + addonsBoxHtml;
    updateCustomizerFooter();
  }

  function updateCustomizerFooter() {
    const totals = calcConfigTotals();
    const sumEl = document.getElementById("dsg-cust-summary");
    if (!sumEl) return;
    const signDelta = totals.exchangeDelta >= 0 ? "+" + fmtMoney(totals.exchangeDelta) : "-" + fmtMoney(Math.abs(totals.exchangeDelta));
    sumEl.innerHTML =
      '<div style="font-size:12.5px;color:var(--text-secondary);">' +
        'Base: <strong>' + fmtMoney(totals.base) + '</strong> &bull; ' +
        'Exchanges: <strong style="color:var(--accent-amber);">' + signDelta + '</strong> &bull; ' +
        'Extra Add-Ons: <strong style="color:var(--accent-emerald);">+' + fmtMoney(totals.addonsTotal) + '</strong>' +
        (totals.storageTotal > 0 ? ' &bull; Off-Site Storage: <strong>+' + fmtMoney(totals.storageTotal) + '</strong>' : '') +
      '</div>' +
      '<div style="font-family:var(--font-mono);font-size:24px;font-weight:900;color:var(--accent-amber);">Configured Total: ' + fmtMoney(totals.grandTotal) + '</div>';
  }

  // -------------------- CART DRAWER --------------------
  function openCartDrawer() {
    const el = document.getElementById("dsg-cart-backdrop");
    if (el) el.classList.add("open");
  }

  function closeCartDrawer() {
    const el = document.getElementById("dsg-cart-backdrop");
    if (el) el.classList.remove("open");
  }

  function renderCartDrawer() {
    const body = document.getElementById("dsg-cart-body");
    const totEl = document.getElementById("dsg-cart-total");
    if (!body || !totEl) return;

    if (cart.length === 0) {
      body.innerHTML = '<p style="color:var(--text-muted);text-align:center;padding:40px 0;">Your deployment manifest is currently empty. Select any Survival Package, Off-Site Storage Bay, or Armory Item to stage your order.</p>';
      totEl.textContent = "$0.00";
      return;
    }

    let grand = 0;
    body.innerHTML = cart.map(function (c, idx) {
      const lineTotal = (c.price || 0) * (c.qty || 1);
      grand += lineTotal;
      const detailsHtml = (c.details || []).map(function (d) {
        return '<div style="font-size:11.5px;color:var(--text-secondary);margin-top:3px;">&bull; ' + esc(d) + '</div>';
      }).join("");
      return '<div class="dsg-cart-item">' +
        '<div style="display:flex;justify-content:space-between;gap:10px;align-items:flex-start;">' +
          '<div>' +
            '<div style="font-family:var(--font-mono);font-size:11px;color:var(--accent-amber);">' + esc(c.type || "EQUIPMENT") + '</div>' +
            '<strong style="font-size:14.5px;">' + esc(c.title) + '</strong>' +
          '</div>' +
          '<button type="button" style="background:none;border:none;color:var(--text-muted);cursor:pointer;font-size:16px;" data-rm-cart="' + idx + '" title="Remove">&times;</button>' +
        '</div>' +
        detailsHtml +
        '<div style="display:flex;justify-content:space-between;align-items:center;margin-top:10px;padding-top:8px;border-top:1px solid var(--border-grid);font-family:var(--font-mono);">' +
          '<span style="font-size:12px;color:var(--text-muted);">Qty: ' + (c.qty || 1) + '</span>' +
          '<strong style="color:var(--accent-amber);">' + fmtMoney(lineTotal) + '</strong>' +
        '</div>' +
      '</div>';
    }).join("");

    totEl.textContent = fmtMoney(grand);
  }

  function exportManifestTxt() {
    if (cart.length === 0) return;
    let lines = [
      "====================================================================",
      "DOOMSDAYSURVIVALIST.COM — CUSTOM DEPLOYMENT & CONTAINER MANIFEST",
      "Generated: " + new Date().toISOString(),
      "====================================================================",
      ""
    ];
    let grand = 0;
    cart.forEach(function (c, i) {
      const sub = (c.price || 0) * (c.qty || 1);
      grand += sub;
      lines.push((i + 1) + ". [" + (c.type || "ITEM") + "] " + c.title + " (Qty: " + (c.qty || 1) + ") — " + fmtMoney(sub));
      (c.details || []).forEach(function (d) {
        lines.push("    - " + d);
      });
      lines.push("");
    });
    lines.push("--------------------------------------------------------------------");
    lines.push("TOTAL DEPLOYMENT VALUE: " + fmtMoney(grand));
    lines.push("Payment Gateways Supported: Authorize.net Tactical / Wire Escrow");
    lines.push("====================================================================");

    const blob = new Blob([lines.join("\n")], { type: "text/plain;charset=utf-8" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "DoomsdaySurvivalist_Custom_Manifest.txt";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  // -------------------- EVENT DELEGATION --------------------
  document.addEventListener("click", function (e) {
    const t = e.target;

    // Toggle 29-item manifest inside package card
    const togBtn = t.closest("[data-toggle-manifest]");
    if (togBtn) {
      const id = togBtn.getAttribute("data-toggle-manifest");
      const box = document.getElementById("manifest-" + id);
      if (box) {
        const open = box.style.display === "block";
        box.style.display = open ? "none" : "block";
        togBtn.innerHTML = open
          ? "&#9662; View All 29 Included Line Items (a&ndash;bb + Container)"
          : "&#9652; Hide Included Package Manifest";
      }
      return;
    }

    // Open Customizer
    const custBtn = t.closest("[data-customize-pkg]");
    if (custBtn) {
      openCustomizer(custBtn.getAttribute("data-customize-pkg"));
      return;
    }

    // Quick-Add Base Package
    const qaBtn = t.closest("[data-quickadd-pkg]");
    if (qaBtn) {
      const pkg = packages.find(function (p) { return p.id === qaBtn.getAttribute("data-quickadd-pkg"); });
      if (pkg) {
        const cnt = skuMap[pkg.containerSku] || {};
        addToCart({
          type: pkg.protocolCode,
          sku: "PKG-0" + pkg.tierNumber,
          title: pkg.protocolCode + ": " + pkg.name,
          price: pkg.retailPrice,
          qty: 1,
          details: [
            "Standard 28-Category Complete Manifest (" + pkg.personnel + ")",
            "Container Included: " + (cnt.name || pkg.containerSku)
          ]
        });
      }
      return;
    }

    // Add Off-Site Storage Plan
    const stBtn = t.closest("[data-add-storage]");
    if (stBtn) {
      const sp = storageMap[stBtn.getAttribute("data-add-storage")];
      if (sp) {
        const isAnnual = storageBilling === "annual";
        addToCart({
          type: "OFF-SITE HARDENED STORAGE",
          sku: sp.id.toUpperCase() + (isAnnual ? "-YR" : "-MO"),
          title: sp.name + (isAnnual ? " (Annual Prepay)" : " (Monthly Plan)"),
          price: isAnnual ? sp.retailAnnual : sp.retailMonthly,
          qty: 1,
          details: [
            "Space: " + sp.unitSize + " | Matched: " + sp.forPackages,
            "2.0x National Avg Space Rate (" + fmtMoney(sp.avgMarketMonthly) + "/mo benchmark)"
          ]
        });
      }
      return;
    }

    // Add Individual Armory SKU
    const skuBtn = t.closest("[data-add-sku]");
    if (skuBtn) {
      const it = skuMap[skuBtn.getAttribute("data-add-sku")];
      if (it) {
        addToCart({
          type: "ARMORY / ADD-ON [" + it.catCode + "]",
          sku: it.sku,
          title: it.name,
          price: it.retailPrice,
          qty: 1,
          details: ["SKU: " + it.sku + " | Lead Time: " + it.leadTime]
        });
      }
      return;
    }

    // Extra Add-On inside Customizer
    if (t.id === "dsg-btn-add-extra" && activeConfig) {
      const selSku = document.getElementById("dsg-extra-addon-sku").value;
      const qtyVal = Math.max(1, parseInt(document.getElementById("dsg-extra-addon-qty").value, 10) || 1);
      activeConfig.extraAddons.push({ sku: selSku, qty: qtyVal });
      renderCustomizerModal();
      return;
    }

    const rmAdBtn = t.closest("[data-remove-addon]");
    if (rmAdBtn && activeConfig) {
      const aIdx = parseInt(rmAdBtn.getAttribute("data-remove-addon"), 10);
      activeConfig.extraAddons.splice(aIdx, 1);
      renderCustomizerModal();
      return;
    }

    // Commit Customized Package to Cart
    if (t.id === "dsg-cust-commit" && activeConfig) {
      const totals = calcConfigTotals();
      const modNotes = [];
      activeConfig.lines.forEach(function (ln) {
        if (ln.selectedSku !== ln.baseSku || ln.selectedQty !== ln.baseQty) {
          const newIt = skuMap[ln.selectedSku] || {};
          modNotes.push("Exchanged [" + ln.catCode + " " + ln.catName + "] -> " + newIt.name + " x" + ln.selectedQty);
        }
      });
      activeConfig.extraAddons.forEach(function (ad) {
        const it = skuMap[ad.sku] || {};
        modNotes.push("Added Extra: " + it.name + " x" + ad.qty);
      });
      if (activeConfig.storageOption !== "none") {
        const sp = storageMap[activeConfig.storagePlanId] || {};
        modNotes.push("Off-Site Storage (" + activeConfig.storageOption + "): " + sp.name);
      }
      if (modNotes.length === 0) {
        modNotes.push("Standard Verified 28-Category + Container Loadout");
      }

      addToCart({
        type: activeConfig.pkg.protocolCode + " (CUSTOMIZED)",
        sku: "PKG-0" + activeConfig.pkg.tierNumber + "-CUSTOM",
        title: activeConfig.pkg.protocolCode + ": " + activeConfig.pkg.name,
        price: totals.grandTotal,
        qty: 1,
        details: modNotes,
        properties: { Configuration: modNotes.join(" | ") }
      });
      closeCustomizer();
      return;
    }

    if (t.closest("[data-close-customizer]") || t.id === "dsg-customizer-backdrop") {
      closeCustomizer();
      return;
    }

    if (t.closest("[data-open-cart]")) {
      openCartDrawer();
      return;
    }

    if (t.closest("[data-close-cart]") || t.id === "dsg-cart-backdrop") {
      closeCartDrawer();
      return;
    }

    const rmCart = t.closest("[data-rm-cart]");
    if (rmCart) {
      removeFromCart(parseInt(rmCart.getAttribute("data-rm-cart"), 10));
      return;
    }

    const billBtn = t.closest("[data-storage-billing]");
    if (billBtn) {
      storageBilling = billBtn.getAttribute("data-storage-billing");
      document.querySelectorAll("[data-storage-billing]").forEach(function (b) {
        b.className = b.getAttribute("data-storage-billing") === storageBilling ? "btn-primary" : "btn-secondary";
      });
      renderOffsiteStorage();
      return;
    }

    if (t.id === "dsg-export-manifest") {
      exportManifestTxt();
      return;
    }

    if (t.id === "dsg-proceed-checkout") {
      if (window.Shopify) {
        window.location.href = "/checkout";
      } else {
        alert("Shopify Checkout Ready!\n\nOn doomsdaysurvivalist.com, this routes directly to your Shopify Authorize.net Tactical / Wire Escrow Checkout with all customized line-item properties attached.\n\nClick 'Download Custom Manifest (.txt)' below to save your itemized configuration.");
      }
      return;
    }
  });

  document.addEventListener("change", function (e) {
    const t = e.target;
    if (t.hasAttribute("data-line-sku") && activeConfig) {
      const idx = parseInt(t.getAttribute("data-line-sku"), 10);
      activeConfig.lines[idx].selectedSku = t.value;
      renderCustomizerModal();
      return;
    }
    if (t.hasAttribute("data-line-qty") && activeConfig) {
      const idx = parseInt(t.getAttribute("data-line-qty"), 10);
      activeConfig.lines[idx].selectedQty = Math.max(1, parseInt(t.value, 10) || 1);
      renderCustomizerModal();
      return;
    }
    if (t.id === "dsg-cust-storage-select" && activeConfig) {
      activeConfig.storageOption = t.value;
      updateCustomizerFooter();
      return;
    }
    if (t.id === "dsg-armory-cat" || t.id === "dsg-armory-source") {
      renderArmoryGrid();
    }
  });

  document.addEventListener("input", function (e) {
    if (e.target && e.target.id === "dsg-armory-search") {
      renderArmoryGrid();
    }
  });

  // -------------------- INITIALIZE --------------------
  function init() {
    renderCategoryChecklist();
    renderCorePackages();
    renderSupremeBunker();
    renderOffsiteStorage();
    populateArmoryFilters();
    renderArmoryGrid();
    renderCartBadge();
    renderCartDrawer();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
